import * as React from "react"
import {Nullable, RecommendedProductType} from "../definitions/types";
import {CrossSellCarouselModel} from "../models/view/crossSellCarouselModel";
import {useProductVariables} from "./useProductVariables";
import {useSuspenseQuery} from "@apollo/client";
import {contentService} from "../api/contentService";
import {RecommendationType} from "../definitions/enums";
import {CrossSellModel} from "../models/domain/crossSellModel";

const defaultModel = {models: undefined, carouselModel: undefined};

export const useRecommendationsCarouselQuery = () => {
    const {variables} = useProductVariables();

    const {data} = useSuspenseQuery(contentService.product.recommendations, {
        errorPolicy: 'all',
        variables: {
            ...variables,
            recommendationType: RecommendationType.UsersWhoBoughtAlsoBought,
        }
    });

    const recommendations = (data?.product?.recommendations?.products ?? [] as Nullable<RecommendedProductType>[])
        .filter((recommendation): recommendation is RecommendedProductType => recommendation !== null)
        .filter((recommendation) => recommendation.productId !== variables.productId)
        .map((recommendation) => new CrossSellModel({
                ...recommendation,
                id: recommendation.productId,
                isDynamicDimension: !!recommendation.dimensionalPrice,
                minQuantity: recommendation.minQuantity ?? 1,
                variantPath: recommendation.path
            }, {
                alt: recommendation.imageAlt,
                title: recommendation.imageTitle,
                url: recommendation.imageSrc
            }, {
                ...recommendation
            },
            recommendation.ratingStatistics));

    // If there are no recommended products, return the default model
    if (recommendations.length === 0) return defaultModel

    return {
        models: recommendations,
        carouselModel: new CrossSellCarouselModel(
            <div className="fs-3 ms-2 p-3">
                Users who bought this also bought
            </div>
        )
    }
}